import { useQuery } from "@tanstack/react-query";
import { fetchConcepts } from "../api/fetchConcepts";
import withPrefix from "../../../helpers/useQueryPrefix";

export const useFetchConcepts = () => {
    return useQuery({
        queryKey: withPrefix(['concepts']),
        queryFn: fetchConcepts,
    })
}
